/* THEONE v46 — homepage layer + PDP drop tracker + name-optional fix. */
(function () {
  var de = (document.documentElement.lang || '').slice(0, 2) === 'de';
  var it = (document.documentElement.lang || '').slice(0, 2) === 'it';

  /* ------------------------------------------------------------------
     DROP PROGRESS — set in snippets/tl-drop.liquid so the launch-day
     numbers can be changed in a 1-line file instead of this one.
     TL_DROP is the drop selling now (every drop before it is sold out),
     TL_DROP_SOLD_PCT how much of it has gone. Her numbers, 9 Oct 2026:
     drops 1, 2 and 3 sold out, drop 4 at 14 percent.
     ------------------------------------------------------------------ */
  var LIVE_DROP = (typeof window.TL_DROP === 'number') ? window.TL_DROP : 4;
  var DROP_SOLD_PCT = (typeof window.TL_DROP_SOLD_PCT === 'number')
    ? window.TL_DROP_SOLD_PCT
    : 14;

  /* the Vault film, 16:9, 49 s (30 Sept 2026, Shopify Video 72179801522506).
     Poster = its first frame, The Path at day 229. */
  var APP_HD = 'https://cdn.shopify.com/videos/c/vp/ab5ba1db939946ff9fbf15fcb328a242/ab5ba1db939946ff9fbf15fcb328a242.HD-720p-1.6Mbps-95992133.mp4';
  var APP_THUMB = 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/ab5ba1db939946ff9fbf15fcb328a242.thumbnail.0000000000.jpg?v=1790763669&width=800';

  /* ------------------------------------------------------------------
     REAL PROMISES — actual customer videos (576x1024, 9:16), every one
     a real TikTok. The watermarks are left ON deliberately: they prove
     this is real social content, not studio footage. SD is used
     (270x480, ~1 to 3 MB) because the tiles render at 180px wide, and
     nothing loads until a tile is tapped (preload none).
     Order is hers (8 Oct 2026): the Italian one first "cuz its actual
     real ugc", then the three she downloaded that day, then the two
     older ones last.
     To add more: upload the video to Content > Files, read its SD
     source and preview image from the Files API
     (files(query: "media_type:VIDEO")), append { src, poster } here.
     ------------------------------------------------------------------ */
  var UGC = [
    {
      /* @soloditommaso — Italian, Love Agreement */
      src: 'https://cdn.shopify.com/videos/c/vp/1db719bdd1144843b348cf2e7c518279/1db719bdd1144843b348cf2e7c518279.SD-480p-0.9Mbps-93278105.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/1db719bdd1144843b348cf2e7c518279.thumbnail.0000000000.jpg?v=1788347325'
    },
    {
      /* customer TikTok, 27 s (Files: theone-ugc-8, 26 Oct 2026) */
      src: 'https://cdn.shopify.com/videos/c/vp/551e2de0b373456689f4e220fd06a378/551e2de0b373456689f4e220fd06a378.SD-480p-0.9Mbps-98938528.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/551e2de0b373456689f4e220fd06a378.thumbnail.0000000000.jpg?v=1793028879'
    },
    {
      /* customer TikTok, 18 s (Files: theone-ugc-9, 26 Oct 2026) */
      src: 'https://cdn.shopify.com/videos/c/vp/6eede52249bc46098b725ce6c6dcd847/6eede52249bc46098b725ce6c6dcd847.SD-480p-0.9Mbps-98938529.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/6eede52249bc46098b725ce6c6dcd847.thumbnail.0000000000.jpg?v=1793028877'
    },
    {
      /* customer TikTok, 8 s (Files: theone-ugc-5, 8 Oct 2026) */
      src: 'https://cdn.shopify.com/videos/c/vp/83d09acc1ca64b758c6684cef85edf4e/83d09acc1ca64b758c6684cef85edf4e.SD-480p-0.9Mbps-96829849.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/83d09acc1ca64b758c6684cef85edf4e.thumbnail.0000000000.jpg?v=1791474222'
    },
    {
      /* customer TikTok, 27 s (Files: theone-ugc-6, 8 Oct 2026) */
      src: 'https://cdn.shopify.com/videos/c/vp/dd87574a4d354a47a9d2da5f6988270b/dd87574a4d354a47a9d2da5f6988270b.SD-480p-0.9Mbps-96829850.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/dd87574a4d354a47a9d2da5f6988270b.thumbnail.0000000000.jpg?v=1791474233'
    },
    {
      /* customer TikTok, 11 s (Files: theone-ugc-7, 8 Oct 2026) */
      src: 'https://cdn.shopify.com/videos/c/vp/add367a22afc49039b012e7900fcd498/add367a22afc49039b012e7900fcd498.SD-480p-0.9Mbps-96829851.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/add367a22afc49039b012e7900fcd498.thumbnail.0000000000.jpg?v=1791474230'
    },
    {
      /* @ashleyyconnor — the box and flowers in the car */
      src: 'https://cdn.shopify.com/videos/c/vp/fad396e9882045fdb51714ddfee1c283/fad396e9882045fdb51714ddfee1c283.SD-480p-0.9Mbps-93278104.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/fad396e9882045fdb51714ddfee1c283.thumbnail.0000000000.jpg?v=1788347327'
    },
    {
      /* @walker_sarah0 — "He just got me a Theone ring 3 months in" */
      src: 'https://cdn.shopify.com/videos/c/vp/75c62aee44f3457f9f10df1af3764c72/75c62aee44f3457f9f10df1af3764c72.SD-480p-0.9Mbps-93279278.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/75c62aee44f3457f9f10df1af3764c72.thumbnail.0000000000.jpg?v=1788348214'
    },
    {
      /* @ashleyyconnor — the Love Agreement, her second film (Files: theone-ugc-1). Not on her list; delete this block to drop it. */
      src: 'https://cdn.shopify.com/videos/c/vp/c9be8e17aed54c23bd07615d10cc3f50/c9be8e17aed54c23bd07615d10cc3f50.SD-480p-0.9Mbps-93278102.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/c9be8e17aed54c23bd07615d10cc3f50.thumbnail.0000000000.jpg?v=1788347325'
    }
  ];

  function ready(f) {
    if (document.readyState !== 'loading') f();
    else document.addEventListener('DOMContentLoaded', f);
  }

  /* ------------------------------------------------------------------
     "Her name" must NEVER block add-to-cart. A required field here stops
     gift buyers who don't want to type a name — it cost real sales and
     was killed once before (v38.1); the fix never travelled into this
     theme lineage, so product.json still carries required:true.
     The block reads `isRequired` once in connectedCallback (parse time),
     so we overwrite the live instance property here. The helper caption
     is hidden entirely (her call). The name still ships when filled.
     ------------------------------------------------------------------ */
  function makeNameOptional() {
    var field = document.querySelector('[class*="ai-personalization-field-"]');
    if (!field) return;
    field.isRequired = false;
    field.dataset.required = 'false';
    var input = field.querySelector('input');
    if (input) input.removeAttribute('aria-required');
    var helper = field.querySelector('[class*="ai-personalization-helper-"]');
    if (helper) helper.style.display = 'none';
    var err = field.querySelector('[class*="ai-personalization-error-"]');
    if (err) err.classList.remove('visible');
  }

  /* drop tracker: every earlier drop sold out · the live one selling now */
  function dropTracker() {
    var SOLD = de ? 'Ausverkauft' : it ? 'Esaurito' : 'Sold out';
    var LIVE = DROP_SOLD_PCT + (de ? '% verkauft' : it ? '% venduto' : '% sold');
    var w = document.createElement('div');
    w.className = 'tlv46-drops' + (LIVE_DROP > 3 ? ' tlv46-drops--four' : '');
    w.setAttribute('role', 'img');
    var label = [];
    var html = '';
    for (var n = 1; n < LIVE_DROP; n++) {
      label.push('Drop ' + n + (de ? ' ausverkauft' : it ? ' esaurito' : ' sold out'));
      html += '<div class="d"><span class="l">Drop ' + n + '</span><span class="t"><i style="width:100%"></i></span><span class="s">' + SOLD + '</span></div>';
    }
    label.push(de
      ? 'Drop ' + LIVE_DROP + ' zu ' + DROP_SOLD_PCT + ' Prozent verkauft'
      : it ? 'Drop ' + LIVE_DROP + ' venduto al ' + DROP_SOLD_PCT + ' per cento'
      : 'Drop ' + LIVE_DROP + ' ' + DROP_SOLD_PCT + ' percent sold');
    html += '<div class="d live"><span class="l">Drop ' + LIVE_DROP + '</span><span class="t"><i style="width:' + DROP_SOLD_PCT + '%"></i></span><span class="s">' + LIVE + '</span></div>';
    w.setAttribute('aria-label', label.join(', '));
    w.innerHTML = html;
    return w;
  }

  /* REAL PROMISES strip: real customer TikToks, built once and placed on the
     homepage (before "Made to be kept") and on every product page (right after
     the buy column, before THE THEONE STANDARD). Her ask, 26 Oct 2026: "put ugc
     on product page ... under buy button or somewhere where it makes most sense". */
  function buildUgc() {
    var sec = document.createElement('section');

    sec.className = 'tlv46-ugc';
    sec.innerHTML =
      '<span class="tlv46-ugc-eyebrow">' + (de ? 'Echte Versprechen' : it ? 'Promesse vere' : 'Real promises') + '</span>' +
      '<h2>' + (de ? 'Gehalten von Paaren wie euch.' : it ? 'Mantenute da coppie come voi.' : 'Kept by couples like you.') + '</h2>' +
      '<div class="tlv46-ugc-row"></div>' +
      '<p class="tlv46-ugc-note">' + (de ? 'Von echten Paaren gefilmt.' : it ? 'Filmate da coppie vere.' : 'Filmed by real couples.') + '</p>';
    var row = sec.querySelector('.tlv46-ugc-row');
    UGC.forEach(function (v) {
      var t = document.createElement('div');
      t.className = 'tlv46-ugc-tile';
      t.innerHTML = '<video preload="none" playsinline loop poster="' + v.poster + '"></video><span class="p"></span>';
      var vid = t.querySelector('video');
      t.addEventListener('click', function () {
        if (vid.paused) {
          if (!vid.getAttribute('src')) vid.src = v.src;
          document.querySelectorAll('.tlv46-ugc-tile video').forEach(function (o) {
            if (o !== vid && !o.paused) { o.pause(); o.closest('.tlv46-ugc-tile').classList.remove('playing'); }
          });
          vid.muted = false;
          var p = vid.play();
          if (p && p.catch) p.catch(function () { vid.muted = true; vid.play().catch(function () {}); });
          t.classList.add('playing');
        } else {
          vid.pause();
          t.classList.remove('playing');
        }
      });
      row.appendChild(t);
    });
    return sec;
  }

  ready(function () {
    var main = document.querySelector('main');
    if (!main) return;

    /* ---- PDP: name optional + the drop tracker under the buy buttons ---- */
    if (main.dataset.template === 'product') {
      makeNameOptional();
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form && !document.querySelector('.tlv46-drops')) {
        var payBtn = document.querySelector('.shopify-payment-button');
        var host = (payBtn && payBtn.closest('form')) ? payBtn : form;
        host.parentNode.insertBefore(dropTracker(), host.nextSibling);
      }
      if (!document.querySelector('.tlv46-ugc')) {
        var mainSec = document.querySelector('.shopify-section[id$="__main"]');
        if (mainSec && mainSec.parentNode) mainSec.parentNode.insertBefore(buildUgc(), mainSec.nextSibling);
      }
      return;
    }

    if (main.dataset.template !== 'index') return;

    /* --- 1 · grid header + drop tracker --- */
    var gridContainer = main.querySelector('[class*="ai-all-products-container-"]');
    if (gridContainer && !document.querySelector('.tlv46-gridhead')) {
      var gh = document.createElement('div');
      gh.className = 'tlv46-gridhead';
      gh.innerHTML = '<span class="eb">' + (de ? 'Die Ringe' : it ? 'Gli anelli' : 'The rings') + '</span><h2>' + (de ? 'Macht eure Liebe unverrückbar.' : it ? 'Suggellate il vostro amore.' : 'Lock your love in.') + '</h2>';
      gh.appendChild(dropTracker());
      gridContainer.parentNode.insertBefore(gh, gridContainer);
    }

    /* --- 2 · mid-page autoplay film = the paper-plane film.
       Since 9 Oct 2026 the block carries this film itself (templates/
       index.json points at theone-vault-film-paperplane-cut.mp4, the
       9 Oct cut that ends on the ring going onto her finger, and
       blocks/ai_gen_block_201b7d6.liquid picks SD or 720p on its own,
       with no <source> to download first). This is only a safety net:
       if the block ever points at another file again, the paper-plane
       film is put back here. When the src already is the paper-plane
       film nothing is touched, so the film is never fetched twice. --- */
    var filmWrap = main.querySelector('[id$="__177895928990947071"] [class*="ai-video-wrapper-"]');
    if (filmWrap) {
      var fv = filmWrap.querySelector('video');
      if (fv && (fv.currentSrc || fv.getAttribute('src') || '').indexOf('d73f3a616e494050b10b7df1cb095523') === -1) {
        var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
        var src = mobile
          ? 'https://cdn.shopify.com/videos/c/vp/d73f3a616e494050b10b7df1cb095523/d73f3a616e494050b10b7df1cb095523.SD-480p-1.5Mbps-96870226.mp4'
          : 'https://cdn.shopify.com/videos/c/vp/d73f3a616e494050b10b7df1cb095523/d73f3a616e494050b10b7df1cb095523.HD-720p-4.5Mbps-96870226.mp4';
        fv.pause();
        Array.prototype.slice.call(fv.querySelectorAll('source')).forEach(function (s) { s.remove(); });
        fv.poster = 'https://cdn.shopify.com/s/files/1/1039/1181/7546/files/preview_images/d73f3a616e494050b10b7df1cb095523.thumbnail.0000000000.jpg?v=1791501506';
        fv.muted = true;
        fv.defaultMuted = true;
        fv.playsInline = true;
        fv.autoplay = true;
        fv.loop = true;
        fv.src = src;
        try { fv.load(); } catch (e) {}
        var fp = fv.play();
        if (fp && fp.catch) fp.catch(function () {});
      }
    }

    /* --- 2b · THE VAULT section film = the APP phone-screen film. --- */
    var tlvhFilm = document.getElementById('tlvh-film');
    if (tlvhFilm && tlvhFilm.parentNode) {
      var poster = tlvhFilm.querySelector('img');
      if (poster) {
        poster.src = APP_THUMB;
        poster.removeAttribute('srcset');
      }
      var clone = tlvhFilm.cloneNode(true);
      tlvhFilm.parentNode.replaceChild(clone, tlvhFilm);
      clone.addEventListener('click', function (e) {
        e.stopPropagation();
        if (clone.querySelector('video')) return;
        clone.innerHTML = '<video src="' + APP_HD + '" controls playsinline preload="auto" poster="' + APP_THUMB + '"></video>';
        var vv = clone.querySelector('video');
        try { var pp = vv.play(); if (pp && pp.catch) pp.catch(function () {}); } catch (err) {}
      });
    }

    /* --- 3 · Real promises strip before "Made to be kept" --- */
    var sec = document.querySelector('.tlv46-ugc');
    if (!sec) {
      sec = buildUgc();
      var kept = document.querySelector('[id$="__1778179842a2295b78"]');
      if (kept) kept.parentNode.insertBefore(sec, kept);
    }

    /* --- 4 · marquee: chapter divider right above the UGC strip.
       The track is two identical halves and the loop slides one half out,
       so each half has to be wider than the screen. With a fixed 8 words
       per half (about 1280px) the right side ran out of words on wider
       screens before the loop restarted. Now the number of word sets
       follows the screen, and the duration follows it too, so the speed
       is the same as before (15 s per set of four). --- */
    if (!document.querySelector('.tlv46-marquee') && sec && sec.parentNode) {
      var words = de
        ? ['Ein Ring', 'Eine Liebe', 'Einmal gekauft', 'Für immer']
        : it ? ['Un anello', 'Un amore', 'Comprato una volta', 'Per sempre']
        : ['One ring', 'One love', 'Bought once', 'Kept forever'];
      var set = '';
      for (var w = 0; w < words.length; w++) {
        set += '<span>' + words[w] + '</span><i>✦</i>';
      }
      var mq = document.createElement('div');
      mq.className = 'tlv46-marquee';
      mq.setAttribute('aria-hidden', 'true');
      mq.innerHTML = '<div class="tlv46-marquee-track">' + set + '</div>';
      sec.parentNode.insertBefore(mq, sec);
      var track = mq.firstChild;
      var setW = track.scrollWidth;
      if (!(setW > 200)) setW = 500;
      var widest = Math.max(window.innerWidth || 0, screen.width || 0, screen.height || 0, 1280);
      var sets = Math.max(2, Math.ceil(widest / setW) + 1);
      var half = '';
      for (var k = 0; k < sets; k++) half += set;
      track.innerHTML = half + half;
      track.style.animationDuration = (sets * 15) + 's';
    }
  });
})();